import axiosInstance from '../axios';
import endpoints from '../endpoints';

const permissionService = {
  // Grant permission to a user
  grantPermission: async (permissionData) => {
    const response = await axiosInstance.post(endpoints.permissions.grant, permissionData);
    return response.data;
  },

  // Revoke permission
  revokePermission: async (permissionId) => {
    const response = await axiosInstance.delete(endpoints.permissions.revoke(permissionId));
    return response.data;
  },

  // Update permission
  updatePermission: async (permissionId, permissionData) => {
    const response = await axiosInstance.put(
      endpoints.permissions.update(permissionId), 
      permissionData
    );
    return response.data;
  },

  // Get my permissions (current user)
  getMyPermissions: async () => {
    const response = await axiosInstance.get(endpoints.permissions.myPermissions);
    return response.data;
  },

  // Get permissions granted by current user
  getGrantedPermissions: async () => {
    const response = await axiosInstance.get(endpoints.permissions.granted);
    return response.data;
  },

  // Get all permissions for a specific user
  getUserPermissions: async (userId) => {
    const response = await axiosInstance.get(endpoints.permissions.userPermissions(userId));
    return response.data;
  }
};

export default permissionService;